import React from "react"
import './styles.scss'
const UnderHeader = ({ title, desc, type }) => {
  return (
    <section className="underheader-wrapper">
      <div className="underheader-container d-flex flex-column justify-content-center">
        <div className="container ">
          <div className="row d-flex justify-content-center">
            <h1 className="underheader-title">{title}</h1>
          </div>
          <div className="row d-flex justify-content-center">
            {desc &&
              <p className="underheader-desc">{desc}</p>
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default UnderHeader
